export default "__VITE_ASSET__DkMfXAr0__"